import { useMutation } from '@tanstack/react-query'

import { api, ApiError } from '@/lib/axios'
import { queryClient } from '@/lib/tanstack'

type ChangeProfilePasswordProps = {
  applicationAccountUsersId: string
  currentPassword: string
  newPassword: string
}

async function changeProfilePassword(data: ChangeProfilePasswordProps) {
  return api.backend.post(
    '/application-account-users-auth/edit-secret-data',
    data,
  )
}

export function useChangeProfilePassword() {
  const { mutateAsync, isPending } = useMutation<
    unknown,
    ApiError,
    ChangeProfilePasswordProps
  >({
    mutationKey: ['/application-account-users-auth/edit-secret-data'],
    mutationFn: changeProfilePassword,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['/user/current-accounts'] })
    },
  })

  return {
    changeProfilePassword: mutateAsync,
    isChangingProfilePassword: isPending,
  }
}
